import _ from 'underscore';
import Backbone from 'backbone';

export default Backbone.Model.extend({
	idAttribute: 'Id',

	defaults: function() {
		return {
			Buy: false,
			Counterparty: 'Unspecified',
			CounterpartyLei: 'Unspecified',
			CounterpartyMemberName: 'Unspecified',
			CounterpartyType: 'Unspecified',
			CtrPtyParticipantId: 0,
			CtrPtyParticipantLei: '',
			CtrPtyParticipantName: '',
			Currency: 'CHF',				// defaults to CHF
			Delayed: false,
			Dividend: null,					// null, true or false
			Email: '',
			Handled: false,
			Inserted: null,					// date
			Instrument: 'Unspecified',
			InstrumentType: 'Unspecified',
			IsDomestic: 'Unspecified',
			Isin: 0,
			Lei: 'Unspecified',
			ParticipantIdentifier: 'unknown',
			NoResults: 'No log enties found',
			OwnTrade: '',
			ParticipantName: '',
			Price: 0,
			Quantity: 0,
			Remarks: '',
			SetHandled: '',					// url to set handled property
			Settlement: null,				// date,
			SettlementAmount: 0,
			Traded: null,					// date
			Type: ''						// type of urgent notification

		};
	},

	url: function() {
		return document.URL;
	},

	initialize: function() {
		this.listenTo(this, 'change:Handled', this.onHandledChanged);
	},

	onHandledChanged: function(model, handled) {
		this.save({}, {
			url: '/extranet/setnotificationhandled?notificationId=' + this.get('Id') + '&handled=' + handled,
			type: 'GET'
		});
	},

	toJSON: function() {
		var data = _.clone(this.attributes);

		return _.extend(data, {
			Buy: (data.Buy === true) ? 'Buy' : 'Sell'
		});
	}
});
